import { useState, useEffect, useContext } from 'react'
import TopNavBar from '../components/navigation/TopNavBar'
import RoundedButton from '../components/buttons/RoundedButton'
import TwoButtonsModal from '../components/modals/TwoButtonsModal'
import LoadingModal from '../components/modals/LoadingModal'
import * as Constants from '../utils/constants'
import { UserContext } from '../App'
import { isExpired } from 'react-jwt'
import { ToastContainer, toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import arrow from '../assets/arrow.png'
import strings from '../res/strings'
import 'react-toastify/dist/ReactToastify.css'

const ClientProfile = () => {
    const [showDeleteClientModal, setShowDeleteClientModal] = useState(false)
    const [user, setUser] = useState(null)

    const [isLoading, setIsLoading] = useState(true)

    const { loggedUser, setLoggedUser } = useContext(UserContext)
    const navigate = useNavigate()

    useEffect(() => {
        if(loggedUser !== null && loggedUser !== 'refresh') {
            const isTokenExpired = isExpired(loggedUser.jwtToken)

            if(isTokenExpired) {
                setLoggedUser(null)
                navigate('/')
            } else if(loggedUser.role === Constants.Roles.CLIENT) {
                getClientDetails()
            } else {
                navigate('/')
            }
        } else if (loggedUser === null) {
            navigate('/')
        }
    }, [loggedUser])

    // Handle get client details
    const getClientDetails = () => {
        fetch(`/api/Backoffice/${loggedUser.userId}/Details`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)

                if (response.status === 200) {
                    const jsonRes = await response.json()

                    setUser(jsonRes)
                } else {
                    showErrorToast(strings.getClientDetailsError)
                    setUser(null)
                }
   
            }, 1000)
    
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setUser(null)
            }, 1000)
        })
    }

    // Show delete modal
    const onClickDelete = () => {
        setShowDeleteClientModal(true)
    }

    // Handles the disposal of a client
    const removeClient = () => {
        setShowDeleteClientModal(false)
        setIsLoading(true)

        // Delete client
        fetch(`/api/BackOffice/${loggedUser.userId}/DeleteUser`, {
            method:'DELETE',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
    
                if (response.status === 200) {
                    setLoggedUser(null)
                    navigate('/')
                }
            }, 1000)
    
        }).catch((error) => {
            setTimeout(() => {
              setIsLoading(false)
              showErrorToast(error)
            }, 1000)
        })
    }

    // Handle show error toast
    const showErrorToast = (error) => {
        toast.error(error, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored'
        })
    }

    return (
        <>
            <TopNavBar />

            <div className='flex flex-col px-[12.5rem] min-h-screen mb-6'>
                { isLoading ?
                    <LoadingModal />
                :   <>
                        <div className='flex flex-row items-center mt-[3.375rem] mb-[1.875rem] space-x-2'>
                            <button onClick={() => navigate(-1)}>
                                <img className='h-5 w-5' src={arrow} alt='Voltar atrás'/>
                            </button>
                            <p className='font-montserrat font-semibold text-accent'>{strings.profile}</p>
                        </div>

                        <div className='flex flex-row'>
                            <div className='flex flex-col w-1/2'>
                                <p className='font-montserrat text-sm'>{strings.accessEmail}</p>
                                <p className='font-montserrat text-xl font-semibold'>{user && user.email}</p>
                            </div>
                            <div className='flex flex-col w-1/2'>
                                <p className='font-montserrat text-sm'>{strings.name}</p>
                                <p className='font-montserrat text-xl font-semibold'>{user && user.name}</p>
                            </div>
                        </div>

                        <div className='flex flex-row mt-8'>
                            <div className='flex flex-col w-1/2'>
                                <p className='font-montserrat text-sm'>{strings.nif}</p>
                                <p className='font-montserrat text-xl font-semibold'>{user && user.nif}</p>
                            </div>
                            <div className='flex flex-col w-1/2'>
                                <p className='font-montserrat text-sm'>{strings.address}</p>
                                <p className='font-montserrat text-xl font-semibold'>{user && user.address}</p>
                            </div>
                        </div>

                        <div className='flex flex-row mt-8'>
                            <div className='flex flex-col w-1/2'>
                                <p className='font-montserrat text-sm'>{strings.zipCode}</p>
                                <p className='font-montserrat text-xl font-semibold'>{user && user.postalCode}</p>
                            </div>
                            <div className='flex flex-col w-1/2'>
                                <p className='font-montserrat text-sm'>{strings.locality}</p>
                                <p className='font-montserrat text-xl font-semibold'>{user && user.locality}</p>
                            </div>
                        </div>
                    
                        <div className='flex flex-row items-center space-x-4 mt-10'>
                            
                            <div className='flex w-60'>
                                <RoundedButton 
                                    onClick={onClickDelete}
                                    text={strings.deleteAccount}
                                    height={48}
                                    bgColor='#E85F5C'
                                />
                            </div>
                        </div>
                    </>
                }

            </div>

            <TwoButtonsModal 
                open={showDeleteClientModal}
                onClose={() => setShowDeleteClientModal(false)}
                title={strings.deleteClient}
                message={strings.deleteClientMessage}
                buttonText1={strings.cancel}
                buttonText2={strings.deleteAccount}
                onClick={removeClient}
            />

            <ToastContainer />
        </>
    )
}

export default ClientProfile